import React from 'react';
import {
    Autocomplete,
    TextField,
    createFilterOptions
} from '@mui/material';

import './autocompleteInput.scss';
export const AutocompleteInput = ({
    label,
    name,
    options,
    disabled,
    error,
    onOptionCreation,
    onChange,
    value,
    key
}) => {

    const filter = createFilterOptions();

    return (
        <Autocomplete
            key={key}
            options={options || []}
            className='autocomplete-input'
            freeSolo
            value={value || ''}
            onChange={(_, newValue) => {
                if (newValue === null) {
                    onChange(null, name);
                    return;
                }
                if (typeof newValue === 'string' || newValue === null) return;
                if (newValue?.inputValue) {
                    onOptionCreation(newValue?.inputValue);
                } else {
                    onChange(newValue.id, name);
                }
            }}
            renderInput={(props) => (
                <TextField
                    {...props}
                    label={label}
                    value={value}
                    size='small' />
            )}
            getOptionLabel={(option) => {
                return option.displayName || '';
            }}
            disabled={disabled}
            filterOptions={(options, params) => {
                const filtered = filter(options, params);

                const { inputValue } = params;
                const isExisting = options.some((option) => inputValue === option.displayName);
                if (inputValue !== '' && !isExisting && onOptionCreation) {
                    filtered.push({
                        inputValue,
                        displayName: `Agregar "${inputValue}"`,
                    });
                }

                return filtered;
            }}
        />

    )
}